import React, { useState, useEffect } from 'react'
//import { useAlert } from 'react-alert'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { GetApi } from '../../../Common/ApiAxios'

import CardTotal2 from '../Atoms/CardTotal2'

const DefaultUrl = '/api/logisticManagement'

const Flex = styled.div`
  display: flex; /* 横並び */
  flex-wrap: wrap;
  width: 100%;
  height: 140px;
  text-align: center;
  vertical-align: middle;
  margin-top: 10px;
  margin-bottom: 10px;
`

const Content = styled.div`
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  width: 90%;
  heigt: 100px;
  margin-left: auto;
  margin-right: auto;

  ::-webkit-scrollbar-corner {
    display: none;
  }
`

// ヘッダー部のカード
const OperationHeader = (props) => {
  const {
    grants,
    dates,
  } = props
  const [quantity,setQuantity] = useState(null);
  //const alert = useAlert();
  //const interval1Ref = useRef(null);

  // 物量計画の週情報の取得
  const apiGetQuantityWeekly = async (targetYMD) => {
    //console.log('call apiGetQuantityWeekly')
    //dispatch(SetLoadSpinner(true))
    if (targetYMD === null) {
      setQuantity(null);
      return;
    }

    const apiUrl = DefaultUrl + '/getQuantityWeekly';
    const param = {
      workplaceId: '000011',
      targetYMD: targetYMD,
    }

    const result = await GetApi(apiUrl, param);

    //dispatch(SetLoadSpinner(false));
    if (result.errorDetail) {
      //alert.error('物量計画の週情報取得失敗');
      setQuantity(null);
    } else {
      //console.log(result);
      setQuantity(result.data);
    }
  }
  
  // 描画時に一度だけ実行
  useEffect(() => {
    if (dates === null || dates === undefined || dates.count === 0) {
      apiGetQuantityWeekly(null);
    } else {
      apiGetQuantityWeekly(dates[0].dateValue);
    }
  }, [])

  //if (!grants || !totalDatas) return null
  return (
    <Flex>
      <Content>
        <CardTotal2 totalData={quantity} type={0}/>
        <CardTotal2 totalData={quantity} type={1}/>
        <CardTotal2 totalData={quantity} type={2}/>
        <CardTotal2 totalData={quantity} type={3}/>
      </Content>
    </Flex>
  )
}

OperationHeader.propTypes = {
  grants: PropTypes.object, // 権限関連
  dates: PropTypes.array, // 日付情報(1週分)
}
  
export default OperationHeader

